import { Avatar } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import Viewer from "react-viewer";
import { useAppDispatch } from "../../redux";
import { useLazyGetAttachmentUrlQuery } from "../../redux/services";
import { closeBackdrop, openBackdrop } from "../../redux/slices/backdrop";

export const AttachmentImage: React.FC<{
    _id?: string,
    file_name: string,
    isPrimary?: string,
    s3Key?: string,
    size?: number,
    status?: 'saved' | 'failed' | 'notUploaded',
    url?: string,
    object_id: string,
    object_type: string
}> = ({
    _id, file_name, object_id, object_type, status, url
}) => {

        const dispatch = useAppDispatch();
        const { enqueueSnackbar } = useSnackbar();
        const [getAttachmentURL] = useLazyGetAttachmentUrlQuery();

        const [attachmentURL, setAttachmentURL] = React.useState<string>(`/imageNotFound.jpg`);
        const [previewImg, setPreviewImg] = React.useState<string>('');

        const onPreviewClick = async () => {
            if (!_id) {
                return false;
            }

            try {
                dispatch(openBackdrop('Loading Preview...'))
                await getAttachmentURL({ id: _id, object_type, object_id }).unwrap().then((res) => {
                    if (res) {
                        setPreviewImg(res);
                    }
                })
            } catch (error) {
                enqueueSnackbar('Unable to load preview', { variant: 'error' });
            } finally {
                dispatch(closeBackdrop());
            }
        };

        React.useEffect(() => {
            if (status === 'saved' && url) {
                setAttachmentURL(url);
            } else if (status === 'notUploaded') {
                getAttachmentURL({ id: _id, object_type, object_id }).unwrap().then((res) => {
                    if (res) {
                        setAttachmentURL(res);
                    }
                })
            } else {
                setAttachmentURL(`/imageNotFound.jpg`);
            }

            // eslint-disable-next-line
        }, [file_name, _id, status]);

        return <>

            <Viewer
                downloadInNewWindow={false}
                downloadable={false}
                visible={previewImg.length > 0 ? true : false}
                onClose={() => { setPreviewImg(''); }}
                images={previewImg.length > 0 ? [{ src: previewImg, alt: file_name }] : [{ src: "", alt: "" }]}
                changeable={false}
                zIndex={1400}
            />

            <Avatar
                onClick={onPreviewClick}
                variant="square"
                sx={{
                    cursor: "pointer",
                    '.MuiAvatar-img': {
                        objectFit: "contain !important"
                    },
                    border: (theme) => `1px solid ${theme.palette.divider}`
                }}
                alt={file_name}
                src={attachmentURL}>
                <img height={"50px"} width={"50px"} src={`/imageNotFound.jpg`} alt={file_name} />
            </Avatar>
        </>
    }